import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

@Component({
  components: {
    'v-scrollbar': async () => import('vue2-scrollbar')
  }
})
class SubNavigationComponent extends Vue {

  private _clearTimeout: any;

  @Prop({ default: '', type: [String] })
  title: string;

  @Prop({ default: '', type: [String] })
  path: string;

  @Prop({ default: false, type: [Boolean] })
  hideAddButton: boolean;

  @Prop({ default: null, type: [String] })
  AddButtonToolTip: string;

  @Prop({ default: false, type: [Boolean] })
  hideEditButton: boolean

  constructor(){
    super()
  }

  get coTitle(): string {
    return this.title;
  }

  get coColor(): string {
    switch (this.title.toLowerCase()) {
      case 'tableau de bord' || 'dashboard' :
        return '#DBDBDB'
      case 'mes tickets' || 'my tickets'  :
        return '#00F4D9'
      case 'mes documents' || 'my documents' :
        return '#FFFF00'
      case 'mon parc' || 'my parc' :
        return '#F92AC2'
      case 'mon agenda' || 'my agenda' :
        return '#00F4D9'
      case 'inspections':
        return '#F92AC2'
      case 'contrôle véhicule':
        return '#F92AC2'
      case 'profil' || 'profile' :
        return '#FFF'
      case 'suivi de chantier' || 'building site monitoring':
        return 'red'
      case 'maintenance books' || 'carnets d\'entretien'  :
        return '#00F4D9'
      default:
        //throw new Error('no border color for this title')
        return '#F92AC2'
    }
  }

  get iconColor(): string {
    return this.coColor === '#FFF' ? '#848484': this.title.toLowerCase() === 'mes documents' ? 'primary' : 'white'
  }

  handleClick() {
    clearTimeout(this._clearTimeout);
    this._clearTimeout = setTimeout(() => {
      this.$emit('add')
    }, 300);
  }

  handleEditClick(){
    clearTimeout(this._clearTimeout)
    this._clearTimeout= setTimeout(()=>{
      this.$emit('edit')
    },300)
  }
}

export default SubNavigationComponent;



// WEBPACK FOOTER //
// ./src/components/sub-navigation/index.ts